var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 14.346,
    viewBox: "0 0 14.857 14.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3140",
    "data-name": "Group 3140",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3139",
    "data-name": "Group 3139",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8487",
    "data-name": "Path 8487",
    d: "M7.176,1.335,8.192,4.463a.485.485,0,0,0,.461.335h3.289a.485.485,0,0,1,.285.878L9.567,7.609a.484.484,0,0,0-.176.542l1.016,3.128a.486.486,0,0,1-.747.543L7,9.888a.486.486,0,0,0-.571,0l-2.66,1.934a.486.486,0,0,1-.747-.543L4.038,8.151a.485.485,0,0,0-.176-.542L1.2,5.676A.485.485,0,0,1,1.486,4.8H4.775a.485.485,0,0,0,.461-.335L6.253,1.335A.485.485,0,0,1,7.176,1.335Z",
    transform: "translate(-0.286 -0.286)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8aca64e34a45a9c4a901aa39b8ddfa5a.svg";
export { ForwardRef as ReactComponent };